import firebase from "firebase";
import axios from "axios";
import {storage} from "../../firebase";
import {CreateQuizEntry} from "./CreateQuizEntry";


//updates quiz data after finishing a question in the assignment
//attempts and if hint is used is logged
//Note: attempts are reset once the student switches out of the assignment, page, or question number
//Rephrased: attempts are only logged for the number of tries on a single question.
export async function UpdateQuizData(indexNum, questionNum, classLevel, attempts, hintBool) {
    let promise = new Promise((resolve => {
        firebase.auth().onAuthStateChanged((user) => {
            if (user) {
                let email = user.email;
                let studentDataIndex;

                //get the student file for quiz data
                const studentFile = firebase.storage().ref().child('students/10' + classLevel + '/quizData.json');
                studentFile.getDownloadURL()
                    .then(url => axios.get(url))
                    .then(res => {
                        let studentData = res.data;
                        for (let i = 0; i < studentData.length; i++) {
                            //find the index for the student file
                            if (studentData[i].email === email) {
                                //log the attempts and hint and update assignment completion
                                studentData[i].assignmentCompletion[indexNum][questionNum] = 1;
                                studentData[i].attempts[indexNum][questionNum] = attempts;

                                //if hint is used, log hint.
                                if(hintBool){
                                    studentData[i].hint[indexNum][questionNum] = 1;
                                }
                            } else {
                                CreateQuizEntry(classLevel)
                            }
                        }

                        const JSONobj = JSON.stringify(studentData);
                        const blobObj = new Blob([JSONobj], {type: "application/json"});
                        const uploadTask = storage.ref('students/10' + classLevel + '/quizData.json').put(blobObj);
                        uploadTask.on(
                            "state_changed",
                            () => {
                            },
                            error => {
                                console.log(error)
                            },
                            () => {
                                storage
                                    .ref("students/10" + classLevel)
                                    .child('quizData.json')
                                    .getDownloadURL()
                                    .then(url => {
                                            console.log(url);
                                            resolve('completed')
                                        }
                                    )
                                    .catch(e => console.log(e));
                            }
                        )
                    });


            }
        });
    }))
    return promise;
}
